export const DenoiserLevel = {
  SOFT: 'SOFT' as const,
  AGGRESSIVE: 'AGGRESSIVE' as const
} as const;

export type DenoiserLevelType = (typeof DenoiserLevel)[keyof typeof DenoiserLevel];
